import * as types from "./appactiontypes";
// /import appService from '../services/appservice'
import menuService from "../overrides/menuservices";

export function setLoading(
  value,
  loadingIndicatorMessage,
  loadingIndicatorOptions
) {
  return {
    type: types.SET_LOADING,
    value,
    loadingIndicatorMessage,
    loadingIndicatorOptions,
  };
}
export function setPreloading(value, loadingIndicatorMessage, loadingIndicatorOptions) {
  return {
    type: types.SET_PRELOADING,
    value,
    loadingIndicatorMessage,
    loadingIndicatorOptions,
  };
}
export function setMessage(message, messageOptions, messageCallback) {
  return {
    type: types.SET_MESSAGE,
    payload: { message, messageOptions, messageCallback },
  };
}
export function closeMessage() {
  return {
    type: types.CLOSE_MESSAGE,
  };
}
export function setTopMessage(message) {
  return {
    type: types.SET_TOP_MESSAGE,
    message,
  };
}
export function removeTopMessage(message) {
  return {
    type: types.REMOVE_TOP_MESSAGE,
    message,
  };
}
export function showMessage(message, messageOptions) {
  return async function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch(setMessage(message, messageOptions, resolve));
    });
  };
}

export function handleError(errorResponse) {
  return async function (dispatch) {
    try {
      return new Promise((resolve, reject) => {
        console.log('SSO handleError')
        let message = null;
        if (
          errorResponse.status !== undefined &&
          errorResponse.responseText !== undefined
        ) {
          if (errorResponse.status === 404) {
            message = "Not found 404";
          } else if (errorResponse.status === 405) {
            message = "Access denied 403";
          } else {
            try {
              let json = JSON.parse(errorResponse.responseText);
              if (json.Message != null) {
                message = json.Message;
              }
            } catch (e) { }
          }
          if (message == null) {
            message =
              "Error " +
              errorResponse.status +
              " " +
              errorResponse.responseText;
          }
        }
        if (message == null) {
          message = "" + errorResponse;
        }
        dispatch(showMessage(message)).then(reject);
      });
    } catch (e) {
      console.log(e);
    }
  };
}
const getUserMenuEnd = (menus) => ({
  type: types.GET_USER_MENU_END,
  payload: menus,
});

export function getUserMenu() {
  return async function (dispatch) {
    try {
      setLoading(true);
      let resp = await menuService.getUserMenu();
      if (resp) {
        dispatch(getUserMenuEnd(resp));
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  };
}

export function showValidationErrors(sr) {
  return async function (dispatch) {
    console.log('SSO showValidationErrors')
    let message = "Validation error(s)\n";
    sr.errors.forEach((error) => {
      message += error.errorMessage + " \n";
    });
    
    console.log('SSO showValidationErrors', message)
    return dispatch(showMessage(message)
      //showTopMessage(message, { autoClose: "n", messageType: "danger" })
    );
  };
}
export function showTopMessage(messageText, messageOptions) {
  if (!messageOptions) messageOptions = {};
  if (!messageOptions.timeout) {
    messageOptions.timeout = 5000;
  }
  if (!messageOptions.messageType) {
    messageOptions.messageType = "default";
  }
  if (!messageOptions.autoClose) {
    messageOptions.autoClose = "y";
  }
  let message = {
    messageText,
    messageOptions,
  };

  return async function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch(setTopMessage(message));
      if (message.messageOptions.autoClose == "y") {
        setTimeout(() => {
          dispatch(removeTopMessage(message));
        }, messageOptions.timeout);
      }
    });
  };
}
/* export function showTopMessage(messageText, messageOptions) {
  if (!messageOptions) messageOptions = {};
  if (!messageOptions.timeout) {
    messageOptions.timeout = 5000;
  }
  if (!messageOptions.messageType) {
    messageOptions.messageType = "default";
  }
  if (!messageOptions.autoClose) {
    messageOptions.autoClose = "y";
  }
  let message = {
    messageText,
    messageOptions,
  };

  return async function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch(setTopMessage(message));
      if (message.messageOptions.autoClose == "y") {
        setTimeout(() => {
          dispatch(removeTopMessage(message));
        }, messageOptions.timeout);
      }
    });
  };
} */
